<template>
	<div id="app" :class="{ 'sidebar-collapsed': sliderCollapsed }">
		<router-view v-if="isLoginPage"></router-view>
		<div v-else :class="['site-shell', { 'site-shell--overlay-header': hasOverlayHeader, 'site-shell--office': isOfficePage }]">
			<appHead></appHead>
			<div :class="['site-shell__body', { 'site-shell__body--overlay-header': hasOverlayHeader }]">
				<appMenu v-if="showSidebar"></appMenu>
				<div class="site-shell__workspace">
					<div :class="['site-shell__content', { 'site-shell__content--flush': $route.meta && $route.meta.noContentPadding }]">
						<router-view v-if="isRouterAlive"></router-view>
					</div>
					<appFooter v-if="showFooter"></appFooter>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import appHead from './app/app-header';
import appMenu from './app/app-menu';
import appFooter from './app/app-footer';
import { mapState, mapGetters } from 'vuex';

export default {
	name: 'FXY',
	components: {
		appHead,
		appMenu,
		appFooter
	},
	provide() {
		return {
			reload: this.reload
		};
	},
	data() {
		return {
			isRouterAlive: true
		};
	},
	computed: {
		...mapState(['sliderCollapsed']),
		...mapGetters(['isAuthenticated']),
		isLoginPage() {
			return this.$route.name === 'Login';
		},
		hasOverlayHeader() {
			return Boolean(this.$route.meta && this.$route.meta.overlayHeader);
		},
		isOfficePage() {
			return Boolean(this.$route.meta && this.$route.meta.section === 'office');
		},
		showSidebar() {
			return !this.isLoginPage && !(this.$route.meta && this.$route.meta.noSidebar);
		},
		showFooter() {
			return !(this.$route.meta && this.$route.meta.noFooter) && this.$route.meta.section !== 'finance';
		}
	},
	methods: {
		reload() {
			this.isRouterAlive = false;
			this.$nextTick(() => {
				this.isRouterAlive = true;
			});
		}
	},
	created() {
		this.$store.dispatch('bootstrap');
	}
};
</script>
